export default "__VITE_ASSET__94372c8c__"